import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const AdminRoute = () => {
  const { accessToken, role } = useAuth();

  // Not logged in → redirect to admin login
  if (!accessToken) return <Navigate to="/admin/login" replace />;

  // Role not yet known → render nothing (prevent loop)
  if (role === null) return null;

  // Logged in but not admin → redirect
  if (role !== "admin") return <Navigate to="/" replace />;

  // Admin allowed → render children
  return <Outlet />;
};

export default AdminRoute;